import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as saveAs from 'file-saver';
import { ClipboardService } from 'ngx-clipboard';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppointmentWorkOrderService } from 'projects/Administration/src/app/business-services/appointment-work-order.service';
import { DocumentService } from 'projects/Administration/src/app/business-services/document.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { WOStatus } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';

@Component({
  selector: 'app-appointment-document',
  templateUrl: './appointment-document.component.html',
  styleUrls: ['./appointment-document.component.css']
})
export class AppointmentDocumentComponent implements OnInit {

  pendingSignDocument: any;
  rejectedDocuments: any;
  isWarrantyChanged: boolean = false;
  isWarrantyDocumentSigned: boolean = false;
  appointmentDetails:any;
  displayDownloadSection:boolean=false;

  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly activeModal: NgbActiveModal,
    private readonly documentService: DocumentService,
    public readonly editAppointmentService: EditAppointmentService,
    private readonly workOrderService: AppointmentWorkOrderService,
    private readonly translate: TranslateService,
    private readonly cookieservice: CookieService,
    private readonly toastrService: ToastrService,
    private clipboardApi: ClipboardService,
  ) { }

  ngOnInit(): void {
    this.GetPendingSignDocument();
    this.GetWarrantyDocumentStatus();
    this.isWarrantyDocumentSigned = this.workOrderService.isWarrantyDocumentSigned;
    this.appointmentDetails = this.editAppointmentService.appointmentDetails;
    if(this.appointmentDetails.workOrderStatusId ==  WOStatus.Closed){
      this.displayDownloadSection = true;
    }
  }
  OnClose() {
    this.activeModal.close({success: false});
  }
  copyDocumentSignUrl() {
    this.clipboardApi.copyFromContent(this.pendingSignDocument.docSignUrl);
  }
  getDate(date){
    return new Date(date);
  }
  //#region Warranty Document
  DownloadWarrantyDocument() {
    let model = {
      LanguageCode: this.cookieservice.get('userSelectedLanguage'),
      AppointmentId: this.editAppointmentService.appointmentDetails.id,
      AppointmentGuid: this.editAppointmentService.appointmentDetails.appointmentGuid,
      WorkOrderNo: this.editAppointmentService.appointmentDetails.workOrderNo,
      DealerId: this.editAppointmentService.appointmentDetails.dealerId
    };
    this.spinner.show();
    this.documentService.DownloadWarrantyDocument(model).toPromise().then(
      (res: any) => {
        if (res && res.responseCode == 200) {
          let blob = Utility.base64toBlob(res.responseObject.fileContents, "application/pdf;charset=utf-8");
          saveAs(blob, res.responseObject.fileDownloadName);
        } else {
        let error: string = "";
          switch (res.responseMessage) {
            case 'data':
              error = this.translate.instant("lblDocumentDetailNotFound");
              break;
            case 'demand':
              error = this.translate.instant("lblWarrantyDemandNotFound");
              break;
            default:
              error = this.translate.instant("lblPdfGenerateError");
              break;
          }
          this.toastrService.error(error);
        }
      }, (_err) => {
        let error = this.translate.instant("lblPdfGenerateError");
        this.toastrService.error(error);
      },).finally(() => {
        this.spinner.hide();
      });
  }
  SendWarrantyDocument(isSend) {
    let model = {
      LanguageCode: this.cookieservice.get('userSelectedLanguage'),
      AppointmentId: this.editAppointmentService.appointmentDetails.id,
      AppointmentGuid: this.editAppointmentService.appointmentDetails.appointmentGuid,
      WorkOrderNo: this.editAppointmentService.appointmentDetails.workOrderNo,
      DealerId: this.editAppointmentService.appointmentDetails.dealerId,
      IsSend: isSend
    };
    this.spinner.show();
    this.documentService.SendWarrantyDocument(model).toPromise().then(
      (res: any) => {
        if (res && res.responseCode == 200) {
          let successMessage: string = "";
          if (isSend) {
            successMessage = this.translate.instant("lblDocumentSentSuccess");
          }
          else{
            successMessage = this.translate.instant("lblDocumentLinkGenerateSuccess");
          }
          this.toastrService.success(successMessage);
          this.GetPendingSignDocument();
        } else {
          let error: string = "";
          switch (res.responseMessage) {
            case 'exists':
              error = this.translate.instant("lblDocumentAlreadySent");
              break;
            case 'signed':
              error = this.translate.instant("lblDocumentAlreadySigned");
              break;
            case 'pending':
              error = this.translate.instant("lblDocumentSignPending");
              break;
            case 'canceled':
              error = this.translate.instant("lblDocumentSignRejected");
              break;
            case 'timedout':
              error = this.translate.instant("lblDocumentSignTimeout");
              break;
            case 'rejected':
              error = this.translate.instant("lblDocumentSignCanceled");
              break;
            case 'data':
              error = this.translate.instant("lblDocumentDetailNotFound");
              break;
            case 'demand':
              error = this.translate.instant("lblWarrantyDemandNotFound");
              break;
            case 'send':
              if (isSend) {
                error = this.translate.instant("lblDocumentSentFailed");
              }
              else{
                error = this.translate.instant("lblDocumentLinkGenerateFailed");
              }
              break;
            default:
              error = this.translate.instant("lblPdfGenerateError");
              break;
          }
          this.toastrService.error(error);
        }
      }, (_err) => {
        let error = this.translate.instant("lblPdfGenerateError");
        this.toastrService.error(error);
      },).finally(() => {
        this.spinner.hide();
      });
  }
  DownloadSignedWarrantyDocument() {
    let model = {
      LanguageCode: this.cookieservice.get('userSelectedLanguage'),
      AppointmentId: this.editAppointmentService.appointmentDetails.id,
      AppointmentGuid: this.editAppointmentService.appointmentDetails.appointmentGuid,
      WorkOrderNo: this.editAppointmentService.appointmentDetails.workOrderNo,
      DealerId: this.editAppointmentService.appointmentDetails.dealerId
    };
    this.spinner.show();
    this.documentService.DownloadSignedWarrantyDocument(model).toPromise().then(
      (res: any) => {
        if (res && res.responseCode == 200) {
          let blob = Utility.base64toBlob(res.responseObject.fileContents, "application/pdf;charset=utf-8");
          saveAs(blob, res.responseObject.fileDownloadName);
        }
        else {
          let error: string = "";
          switch (res.responseMessage) {
            case 'pending':
              error = this.translate.instant("lblDocumentSignPending");
              break;
            case 'canceled':
              error = this.translate.instant("lblDocumentSignRejected");
              break;
            case 'timedout':
              error = this.translate.instant("lblDocumentSignTimeout");
              break;
            case 'rejected':
              error = this.translate.instant("lblDocumentSignCanceled");
              break;
            default:
              error = this.translate.instant("lblDocumentNotFound");
              break;
          }
          this.toastrService.error(error);
        }
      }, (_err) => {
        let error = this.translate.instant("lblPdfGenerateError");
        this.toastrService.error(error);
      }).finally(() => {
        this.spinner.hide();
      });
  }
  GetPendingSignDocument(){
    this.spinner.show();
    this.documentService.GetPendingSignDocument(this.editAppointmentService.appointmentDetails.workOrderNo).then(
    (res: any) => {
      if (res?.responseCode === 200 && res?.responseObject?.pendingDocs) {
        this.pendingSignDocument = res.responseObject.pendingDocs;
        let sentInDoc = this.pendingSignDocument.demandIds?.split(",");
        let warrantyDemands = this.workOrderService.appointmentDemandList.filter(x=>x.isInWarranty);
        if (sentInDoc?.length > 0) {
          warrantyDemands.forEach(d => {
            if (!sentInDoc.includes(d.id.toString())) {
              this.isWarrantyChanged = true;
            }
          });
          sentInDoc.forEach(d => {
            if (!warrantyDemands.find(x=>x.id.toString() == d)) {
              this.isWarrantyChanged = true;
            }
          });
        }
      }
      if (res?.responseCode === 200 && res?.responseObject?.rejectedDocs) {
        this.rejectedDocuments = res.responseObject.rejectedDocs;
      }
    }).finally(()=>{
      this.spinner.hide();
    });
  }
  async GetWarrantyDocumentStatus(){
    let workOrderNo = this.editAppointmentService.appointmentDetails.workOrderNo;
    let dealerId = this.editAppointmentService.appointmentDetails.dealerId;
    await this.documentService.WarrantyDocumentStatus(workOrderNo,dealerId).then(
      (res)=>{
          this.isWarrantyDocumentSigned = res.responseObject;
          this.workOrderService.isWarrantyDocumentSigned = res.responseObject;
      }
    );
  }

  //#endregion
}
